<template>
    <div class="truth-myth"
         :class="component_type"
         :id="component_type+'_truth_myth_'+currentQuestion.id"
    >
        <div class="widget pt-3 pb-3" v-if="component_type === 'widget'">
            <h5 v-text="component_title"></h5>
            <span v-show="!currentQuestion.answered" class="question pb-3">{{currentQuestion.question}}</span>
            <div v-show="!currentQuestion.answered" class="answer-buttons row no-gutters justify-content-around">
                <span @click="checkAnswer('truth')" class="btn truth-btn">Verdade</span>
                <span @click="checkAnswer('myth')" class="btn myth-btn">Mito</span>
            </div>
            <h6 v-show="currentQuestion.answered" class="answer" :class="currentQuestion.correct ? 'correct' : 'wrong'" v-text="currentQuestion.answer === 'truth' ? 'Verdade' : 'Mito'"></h6>
            <span v-show="currentQuestion.answered" class="question">{{currentQuestion.answerDescription}}</span>
            <span class="next" v-show="currentQuestion.answered && current < questions.length-1" @click="nextAnswer">Próxima</span>
        </div>
        <div class="myth-component p-5"
             v-if="component_type === 'component'"
             :class="{'hide-controlls' : !this.questions[this.current].answered}"
        >
            <VueSlickCarousel
                ref="slick"
                v-bind="slickSettings"
                class="article-slider-content"
                v-if="questions.length > 0"
                @afterChange="slideChange"
                @reInit="testEvent"
            >
                <article class="component-item pl-5 pr-5" v-for="question in questions">
                    <header class="mb-4" v-text="question.theme"></header>
                    <h5 v-show="!question.answered">{{question.question}}</h5>
                    <div v-show="!question.answered" class="answer-buttons row justify-content-center pt-4 pb-5">
                        <span @click="checkAnswer('truth')" class="btn truth-btn ml-4 mr-4" v-text="truth_label"></span>
                        <span @click="checkAnswer('myth')" class="btn myth-btn ml-4 mr-4" v-text="myth_label"></span>
                    </div>
                    <div class="row" v-show="question.answered">
                        <div class="col-12 col-md-4 text-right pr-3"><img :src="question.image" /></div>
                        <div class="col-12 col-md-7 text-left pr-3">
                            <h6 v-text="question.answer === 'myth' ? myth_label : truth_label"
                                :class="question.correct ? 'correct' : 'wrong'">
                            </h6>
                            <span class="answer-description">{{question.answerDescription}}</span>
                        </div>
                        <div class="col-12 pt-4 pb-4">
                            <span class="next" @click="nextAnswer" v-text="next_label" v-show="current < (questions.length - 1)"></span>
                        </div>
                    </div>
                </article>
            </VueSlickCarousel>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";

export default {
    components: {VueSlickCarousel},
    props:{
        component_data: Object,
        component_type: String,
        truth_label: String,
        myth_label: String,
        next_label: String,
        component_title: String,
    },
    data: () => {
        return {
            questions: [],
            current: 0,
            slickSettings: {
                arrows: true,
                adaptiveHeight: true,
                draggable: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                infinite: false,
                speed: 300,
                variableWidth: false,
            }
        }
    },
    computed:{
        currentQuestion: function(){
            return this.questions[this.current]
        }
    },
    methods:{
        checkAnswer(answer){
            this.questions[this.current].answered = true;
            this.questions[this.current].correct = this.questions[this.current].answer == answer;
            this.$forceUpdate()
        },
        testEvent(){
            this.current = this.$refs.slick.$refs.innerSlider.currentSlide;
        },
        nextAnswer(){
            this.$refs.slick.next();
        },
        slideChange(){
            this.current = this.$refs.slick.$refs.innerSlider.currentSlide;
            this.$forceUpdate()
        }
    },
    beforeMount() {
        Object.keys(this.component_data).forEach((questionID, index)=>{
            this.questions[index] = this.component_data[questionID];
            this.questions[index].id = questionID;
            this.questions[index].answered = false;
            this.questions[index].correct = false;
        })
    },
    updated(){

    }
}
</script>
